// extracted by mini-css-extract-plugin
export default {"ovalWrapperInner":"TipTrigger_ovalWrapperInner__lQMYc","oval":"TipTrigger_oval__zioPs","ovalText":"TipTrigger_ovalText__6UwxZ"};